export { PromoRateCodeInput } from './PromoCodeInput';
export type { PromoRateCodeInputProps } from './PromoCodeInput';
